// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import 'js-cookie'
import './permission' // permission control
import './icons' // icon
import axios from 'axios';

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import Echarts from 'echarts'
import Common from './utils/common'
import DigitalConversion from './utils/digitalConversion'
import VueCropper from 'vue-cropper'
import './utils/jquery-3.5.1.min' //引用全局jquery
import './utils/dialogdrage' //引用全局两种弹出框拖动
import DateUtil from './utils/dateUtil' // 时间处理函数

// 引入全局样式文件
import './assets/styles/business/home/enterprise/home.css'
import './assets/styles/global.scss'
import './assets/styles/red.css'

//引入video.js
import VideoJs from 'video.js'
import 'video.js/dist/video-js.css'
Vue.prototype.$video = VideoJs; //视频播放JS

Vue.prototype.echarts = Echarts;  // Echarts
Vue.prototype.common = Common; // 全局common常量
Vue.prototype.eventBus = new Vue();  // 全局消息机制
Vue.prototype.$DigitalConversion = DigitalConversion;//全局数字类型转换
Vue.prototype.$axios = axios;
Vue.prototype.$dateUtil = DateUtil;


Vue.use(VueCropper); //图片剪切
Vue.use(Element);
Vue.use(Echarts);
Vue.use(Common);

// 该指令的作用是dom渲染后触发，因为非vue的插件有的是dom必须存在的情况下才可以执行，集成富文本编辑器时用到
Vue.directive('loaded-callback', {
  inserted: function (el, binding, vnode) {
    binding.value(el, binding, vnode)
  }
});

// 自定义dialog距顶部的高度
Vue.directive('alterELDialogMarginTop'/*修改elementUI中el-dialog顶部的距离,传入值eg:{marginTop:'5vh'} */, {
  inserted(el, binding, vnode) {
    el.firstElementChild.style.marginTop = binding.value.marginTop
  }
});

// 自定义dialog的高度
Vue.directive('alterELDialogHeight'/*修改elementUI中el-dialog顶部的距离,传入值eg:{marginTop:'5vh'} */, {
  inserted(el, binding, vnode) {
    el.firstElementChild.style.height = binding.value.height
  }
});

Vue.config.productionTip = false;

// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// 例子：
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
Date.prototype.Format = function (fmt) { //author: meizz
  let o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (let k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
};

/* eslint-disable no-new */
const vue = new Vue({
  el: '#app',
  data: function () {
    return {
      articleTableLoading: false,
    }
  },
  store,
  router,
  components: { App },
  template: '<App/>'
});

export default vue



// WEBPACK FOOTER //
// ./src/main.js